import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { SingleDpiaInput } from "../../shared/SingleDpiaInput";

export const Dpia: FC<InputProps<string>> = props => <SingleDpiaInput {...props} />;
